<script lang="ts" setup>
import InterviewSectionItem from '~/components/specialist/InterviewSectionItem.vue'

const items = [
  {
    content: 'Это гарантирует, что эксперт имеет необходимую квалификацию и знания, чтобы предоставлять качественные услуги',
    icon: 'outlined/verify-doc',
    title: 'Проверка наличия профильного образования'
  },
  {
    content: 'Наша программа включает в себя регулярное обучение, развитие и поддержку экспертов, что обеспечивает специалиста знаниями о современных методах и практиках работы в своей отрасли',
    icon: 'outlined/partner',
    title: 'Обучение по партнерской программе iTAB'
  },
  {
    content: 'Мы гарантируем, что каждый специалист обладает необходимыми знаниями и опытом, соответствующими высочайшим стандартам.',
    icon: 'outlined/partner',
    title: 'Прозрачный и тщательный отбор'
  },
  {
    content: 'Только сертифицированные и лицензированные эксперты, прошедшие проверку актуальности их документов.',
    icon: 'outlined/partner',
    title: 'Документированная квалификация'
  },
  {
    content: 'Наши специалисты обладают многолетним опытом работы и могут похвастаться рекомендациями от довольных клиентов.',
    icon: 'outlined/partner',
    title: 'Глубокий профессиональный опыт'
  },
  {
    content: 'Мы сотрудничаем только с теми, кто стремится к постоянному совершенствованию и повышению квалификации.',
    icon: 'outlined/partner',
    title: 'Непрерывное развитие и обучение'
  },
  {
    content: 'Наши специалисты всегда готовы предложить индивидуальные решения и оказать помощь, когда это нужно.',
    icon: 'outlined/partner',
    title: 'Поддержка в любое время'
  },
  {
    content: 'На платформе только лучшие профессионалы, готовые решать задачи любой сложности.',
    icon: 'outlined/partner',
    title: 'Широкий спектр экспертов'
  },
  {
    content: 'Мы работаем только с проверенными экспертами, с которыми нас связывает многолетнее сотрудничество и доверие.',
    icon: 'outlined/partner',
    title: 'Долгосрочное партнерство с лучшими'
  },
]

let autoplayTimer: ReturnType<typeof setInterval> | null = null

const currentGroupIndex = ref(0)

const groupedItems = computed(() => {
  const groups = []

  for (let i = 0; i < items.length; i += 2) {
    groups.push(items.slice(i, i + 2))
  }

  return groups
})

function startAutoplay (): void {
  autoplayTimer = setInterval(() => {
    currentGroupIndex.value = (currentGroupIndex.value + 1) % groupedItems.value.length
  }, 7500)
}

onMounted(() => {
  startAutoplay()
})

onUnmounted(() => {
  if (autoplayTimer) {
    clearInterval(autoplayTimer)
  }
})
</script>

<template>
  <article class="w-full">
    <h1 class="!mb-4 text-[24px] leading-[1.17] md:!mb-7 md:text-[40px] md:leading-[1.1]">
      Как отбираем специалистов
    </h1>

    <div class="mt-5 flex flex-col md:flex-row md:items-stretch">
      <div
        class="
          relative flex min-h-[106px] basis-full items-center overflow-hidden rounded-3xl bg-main-green
          md:mr-4 md:basis-1/2 md:justify-center
        "
      >
        <h2
          class="
            z-40 !m-0 px-4 text-lg font-medium leading-[1.22] text-white
            md:text-center md:text-4xl md:tracking-[-0.03em]
          "
        >
          Только сертифицированные специалисты, прошедшие строгий отбор
        </h2>

        <SvgIcon class="absolute z-10 !size-96" name="brands/itab-big" />
      </div>

      <div class="mt-4 flex basis-full flex-col md:mt-0 md:basis-1/2">
        <div class="relative min-h-[300px] overflow-hidden md:min-h-[350px]">
          <transition name="slide-up">
            <div :key="currentGroupIndex" class="absolute !h-full w-full">
              <InterviewSectionItem
                v-for="(x, index) in groupedItems[currentGroupIndex]"
                :key="index"
                class="mb-3"
                :content="x.content"
                :icon="x.icon"
                :title="x.title"
              />
            </div>
          </transition>
        </div>
      </div>
    </div>
  </article>
</template>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.6s cubic-bezier(0.25, 0.8, 0.5, 1);
  position: absolute;
  width: 100%;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(-50%);
  opacity: 0;
}

.slide-up-enter-to,
.slide-up-leave-from {
  transform: translateY(0);
  opacity: 1;
}
</style>
